import ProjectList from "../../slices/project/project/ProjectList";
import ProjectDetails from "../../slices/project/project/ProjectDetails";
import ProjectStageDetails from "../../slices/project/project/ProjectStageDetails";

const projectReducer = {
    projectList: ProjectList,
    projectDetails: ProjectDetails,
    projectStageDetails: ProjectStageDetails,
};

export default projectReducer;